import React from 'react';
import RewardCard from './RewardCard';

const rewards = [
  {
    vBucks: 1000,
    credits: 5000,
    popular: false
  },
  {
    vBucks: 2800,
    credits: 13000,
    popular: true
  },
  {
    vBucks: 5000,
    credits: 22000,
    popular: false
  }
];

function RewardsSection() {
  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-[#0dceda]/5" id="rewards">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-[#0dceda] to-white text-transparent bg-clip-text">
          Exchange Credits for V-Bucks
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {rewards.map((reward, index) => (
            <RewardCard key={index} {...reward} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default RewardsSection;